import { createContext, useContext } from "react";
import type { LookupSnapshot } from "@capture/rules-engine";

/**
 * P1 — capped lookup snapshots for the current job type (keyed by table name),
 * so FieldInput's blur evaluator can resolve a `lookup`-source branch-IF the
 * same way the server does. Default is empty — a component rendered without a
 * provider simply has no lookup context (a lookup condition resolves null,
 * fail-open on the client; the server stays authoritative). Kept separate from
 * ContentValidateContext so the rule-bundle context shape (and its many
 * existing test providers) is untouched.
 */
export const LookupSnapshotContext = createContext<Record<string, LookupSnapshot>>({});

export function useLookupSnapshots(): Record<string, LookupSnapshot> {
  return useContext(LookupSnapshotContext);
}

/**
 * P8 (deferred VS wiring, applied at merge) — job-level constants from the
 * validate bundle, so a `constant`-value condition or `{const.*}` formula in a
 * blur branch-IF resolves client-side the same way the server does. Same
 * fail-open stance as lookups: no provider → empty → resolves null client-side,
 * server stays authoritative.
 */
export const JobConstantsContext = createContext<Record<string, string | number>>({});

export function useJobConstants(): Record<string, string | number> {
  return useContext(JobConstantsContext);
}
